export default [
  {
    lat: '49.126668',
    lng: '-122.715441',
    locations: [
      {
        name: '7-Home Subdivision',
        lat: '49.126668',
        lng: '-122.715441',
      },
      {
        name: '15-Home Subdivision',
        lat: '49.119059',
        lng: '-122.756426',
      },
      {
        name: '25-Home Subdivision',
        lat: '49.137580',
        lng: '-122.823375',
      },
      {
        name: '12-Home Subdivision',
        lat: '49.133987',
        lng: '-122.812138',
      },
      {
        name: 'Commercial Development',
        lat: '49.155755',
        lng: '-122.801473',
      },
      {
        name: '10-Home Subdivision',
        lat: '49.155740',
        lng: '-122.796451',
      },
      {
        name: '22-Home Subdivision',
        lat: '49.155783',
        lng: '-122.801495',
      },
    ],
  },
  {
    lat: '49.182312',
    lng: '-123.093933',
    locations: [
      {
        name: 'Custom Single-Family Residence',
        lat: '49.182312',
        lng: '-123.093933',
      },
      {
        name: 'Multi-Family Residences',
        lat: '49.138078',
        lng: '-123.128410',
      },
      {
        name: 'Multi-Family Residences',
        lat: '49.135917',
        lng: '-123.117586',
      },
      {
        name: 'Multi-Family Project Management',
        lat: '49.180344',
        lng: '-123.074616',
      },
    ],
  },
  {
    lat: '49.260724',
    lng: '-123.110753',
    locations: [
      {
        name: 'Heritage Multi-Family Residences',
        lat: '49.260724',
        lng: '-123.110753',
      },
      {
        name: 'Custom Single-Family Residence',
        lat: '49.260888',
        lng: '-123.146841',
      },
      {
        name: 'Custom Single-Family Project Management',
        lat: '49.258964',
        lng: '-123.167498',
      },
    ],
  },
  {
    lat: '49.344154',
    lng: '-123.042498',
    locations: [
      {
        name: 'Custom Single-Family Residence',
        lat: '49.344154',
        lng: '-123.042498',
      },
      {
        name: 'Custom Single-Family Residence',
        lat: '49.325706',
        lng: '-123.001260',
      },
      {
        name: 'Custom Single-Family Residence',
        lat: '49.314560',
        lng: '-123.044674',
      },
      {
        name: 'Custom Single-Family Project Management',
        lat: '49.282806',
        lng: '-122.992247',
      },
    ],
  },
  {
    lat: '49.048575',
    lng: '-122.759403',
    locations: [
      {
        name: '15 Single Family Homes',
        lat: '49.048575',
        lng: '-122.759403',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/map.js